export default __webpack_public_path__ + "static/media/screen.05a3fbac.png";